module.exports = __webpack_public_path__ + "img/19.a16f6e14.jpg";